import axios from "axios";
import { showAlert } from "../../utils/alert";

export default () => ({
  isLoading: true,
  invoiceUrl: null,
  status: "PENDING",
  pollingInterval: null,

  async init() {
    const token = localStorage.getItem("jwt_token");
    if (!token) {
      window.location.href = "/client/login";
      return;
    }

    // Explicitly define that we expect JSON responses to prevent Laravel
    // from attempting HTML redirects on AuthenticationException
    window.axios.defaults.headers.common["Accept"] = "application/json";
    window.axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
    window.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`;

    await this.fetchStatus(true);

    if (this.status !== "ACTIVE") {
      this.startPolling();
    }
  },

  async fetchStatus(isInitialLoad = false) {
    try {
      // Mantive a sua correção do /api/ adicionada na URL
      const response = await axios.get("/client/checkout/status");

      this.invoiceUrl = response.data.invoice_url;
      this.status = response.data.status;

      // Se a conta está ATIVA
      if (response.data.is_active) {
        if (isInitialLoad) {
          // Se já estava ativa no momento que ele abriu a URL (tentou ser espertinho)
          // Redireciona na hora, silenciosamente, sem mensagem de sucesso.
          window.location.href = "/client/dashboard";
          return;
        } else {
          // Se ativou durante o polling (ou seja, ele acabou de pagar na nossa cara)
          this.unlockSystem();
        }
      }
    } catch (error) {
      if (error.response?.status === 401) {
        this.stopPolling();
        window.location.href = "/client/login";
      }
    } finally {
      // Só tira a tela de loading se não redirecionou na checagem inicial
      if (this.status !== "ACTIVE" || !isInitialLoad) {
        this.isLoading = false;
      }
    }
  },

  startPolling() {
    this.pollingInterval = setInterval(() => {
      // Passamos "false" porque aqui é o monitoramento contínuo
      this.fetchStatus(false);
    }, 5000);
  },

  stopPolling() {
    if (this.pollingInterval) {
      clearInterval(this.pollingInterval);
    }
  },

  async unlockSystem() {
    this.stopPolling();
    await showAlert("Pagamento confirmado! Acessando o sistema...", "success");
    window.location.href = "/client/dashboard";
  },

  /**
   * Abre o ambiente blindado do Asaas em uma nova aba
   */
  openSecureCheckout() {
    if (this.invoiceUrl) {
      window.open(this.invoiceUrl, "_blank");
    } else {
      showAlert(
        "O link de pagamento ainda não está disponível. Tente atualizar a página.",
        "warning",
      );
    }
  },
});
